import React, { Component } from 'react'
import { connect } from 'react-redux'
import { basketClear } from '../../actions/orders'
import ConfirmPopup from "../common/confirm-popup";
import { history } from "../../store";

class RestartOrder extends Component {

  constructor(props) {
    super(props);
    this.state = { showChangeStoreModal: false };
  }

  toggleChangeStoreDialog = () => {
    this.setState({ showChangeStoreModal: !this.state.showChangeStoreModal });
  };

  handleChangeStore = (confirmed) => {
    if (confirmed) {
      this.clearBasket()
      if (this.props.onClick) { this.props.onClick() }
      history.push('/order/new')
    }
    this.toggleChangeStoreDialog()
  }

  clearBasket = () => {
    this.props.dispatch(basketClear())
  };

  renderChangeStoreConfirmModal() {
    return (
      this.state.showChangeStoreModal &&
      <ConfirmPopup
        onClose={this.handleChangeStore}
        header='Restart Your Order'>
        <p>Are you sure you want to restart your order?</p>
      </ConfirmPopup>
    )
  }

  render() {
    return (
      <div>
        {this.renderChangeStoreConfirmModal()}
        <div className='delivery-address-restart pull-right text-danger'
             onClick={this.toggleChangeStoreDialog}>Change delivery address and restart order
        </div>
      </div>
    )
  }
};

export default connect()(RestartOrder);



// WEBPACK FOOTER //
// ./src/components/new-order/restart-order.jsx